module.exports = __webpack_public_path__ + "img/556.0a272927.png";